/* LQK Daily Huruf Challenge — one mystery letter per day (Singapore time),
   guess it from the clues. Streak lives in localStorage only — no accounts.
   Depends on lqk-games-kit.js */
(function () {
  'use strict';
  var root = document.querySelector('[data-lqkg-daily]');
  if (!root || !window.LQKG) return;
  var K = window.LQKG;

  /* [glyph, name, dots, familyIndex] — alphabet order */
  var HURUF = [
    ['ا', 'alif', 0, 6], ['ب', 'ba', 1, 0], ['ت', 'ta', 2, 0], ['ث', 'tha', 3, 0],
    ['ج', 'jim', 1, 1], ['ح', 'ha', 0, 1], ['خ', 'kha', 1, 1], ['د', 'dal', 0, 2],
    ['ذ', 'dhal', 1, 2], ['ر', 'ra', 0, 2], ['ز', 'zay', 1, 2], ['س', 'sin', 0, 3],
    ['ش', 'shin', 3, 3], ['ص', 'sad', 0, 3], ['ض', 'dad', 1, 3], ['ط', 'tha (heavy)', 0, 4],
    ['ظ', 'zha', 1, 4], ['ع', 'ain', 0, 4], ['غ', 'ghain', 1, 4], ['ف', 'fa', 1, 5],
    ['ق', 'qaf', 2, 5], ['ك', 'kaf', 0, 6], ['ل', 'lam', 0, 6], ['م', 'mim', 0, 6],
    ['ن', 'nun', 1, 0], ['ه', 'ha (soft)', 0, 6], ['و', 'waw', 0, 5], ['ي', 'ya', 2, 0]
  ];
  var MAX_GUESSES = 6;
  var STORE_KEY = 'lqkg-daily';

  var rowsEl = root.querySelector('[data-rows]');
  var kbEl = root.querySelector('[data-kb]');
  var statusEl = root.querySelector('[data-status]');
  var guessChip = root.querySelector('[data-guesses]');
  var streakChip = root.querySelector('[data-streak]');
  K.soundButton(root.querySelector('[data-sound]'));
  var modal = K.modal();

  /* --- Singapore day + deterministic daily letter --- */
  function sgDateStr() {
    var now = new Date(Date.now() + 8 * 3600 * 1000);
    return now.getUTCFullYear() + '-' + ('0' + (now.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + now.getUTCDate()).slice(-2);
  }
  function fnv(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = (h * 16777619) >>> 0;
    }
    return h;
  }
  var today = sgDateStr();
  var answerIdx = fnv('lqk-huruf-' + today) % HURUF.length;
  var ANSWER = HURUF[answerIdx];

  /* --- persistent state --- */
  function load() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }
  function save(s) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(s)); } catch (e) {}
  }
  var state = load();
  if (state.date !== today) {
    /* a missed day breaks the streak (yesterday's win keeps it alive) */
    var yesterday = (function () {
      var d = new Date(Date.now() + 8 * 3600 * 1000 - 86400 * 1000);
      return d.getUTCFullYear() + '-' + ('0' + (d.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + d.getUTCDate()).slice(-2);
    })();
    if (state.lastWinDate !== yesterday && state.lastWinDate !== today) state.streak = 0;
    state.date = today;
    state.guesses = [];
    state.done = false;
    state.won = false;
    save(state);
  }
  state.streak = state.streak || 0;

  var guesses = state.guesses || [];

  /* --- UI builders --- */
  function clueChips(idx) {
    var g = HURUF[idx];
    if (idx === answerIdx) return '<span class="lqkg-daily__clue lqkg-daily__clue--good">✓ You found it!</span>';
    var chips = '';
    if (g[2] === ANSWER[2]) chips += '<span class="lqkg-daily__clue lqkg-daily__clue--good">● same dots (' + ANSWER[2] + ')</span>';
    else chips += '<span class="lqkg-daily__clue">● mystery has ' + (ANSWER[2] > g[2] ? 'more' : 'fewer') + ' dots</span>';
    if (g[3] === ANSWER[3]) chips += '<span class="lqkg-daily__clue lqkg-daily__clue--good">✿ same shape family!</span>';
    chips += '<span class="lqkg-daily__clue lqkg-daily__clue--dir">' + (answerIdx > idx ? 'later in the alphabet ←' : '→ earlier in the alphabet') + '</span>';
    return chips;
  }

  function renderRow(idx, animate) {
    var row = document.createElement('div');
    row.className = 'lqkg-daily__row' + (idx === answerIdx ? ' is-win' : '');
    row.innerHTML =
      '<span class="lqkg-daily__row-letter">' + HURUF[idx][0] + '</span>' +
      '<span class="lqkg-daily__clues">' + clueChips(idx) + '</span>';
    rowsEl.appendChild(row);
    if (animate && !K.reducedMotion) requestAnimationFrame(function () { requestAnimationFrame(function () { row.classList.add('is-in'); }); });
    else row.classList.add('is-in');
  }

  function buildKeyboard() {
    kbEl.innerHTML = '';
    HURUF.forEach(function (h, i) {
      var key = document.createElement('button');
      key.type = 'button';
      key.className = 'lqkg-daily__key';
      key.textContent = h[0];
      key.setAttribute('aria-label', h[1]);
      if (guesses.indexOf(i) !== -1) {
        key.disabled = true;
        if (i === answerIdx) key.classList.add('is-hit');
      }
      key.addEventListener('click', function () { guess(i, key); });
      kbEl.appendChild(key);
    });
  }

  function updateChips() {
    guessChip.textContent = guesses.length + '/' + MAX_GUESSES;
    streakChip.textContent = state.streak;
  }

  function countdown() {
    var now = Date.now() + 8 * 3600 * 1000;
    var midnight = Math.ceil(now / 86400000) * 86400000;
    var left = Math.max(0, midnight - now);
    var h = Math.floor(left / 3600000), m = Math.floor(left % 3600000 / 60000);
    return h + 'h ' + m + 'm';
  }

  function setStatus() {
    if (state.done) {
      statusEl.innerHTML = (state.won ? 'Solved! ' : 'The letter was <b style="font-family:Amiri,serif">' + ANSWER[0] + '</b> (' + ANSWER[1] + '). ') +
        'New huruf in <span class="lqkg-daily__countdown">' + countdown() + '</span>';
      kbEl.querySelectorAll('button').forEach(function (b) { if (!b.classList.contains('is-hit')) b.disabled = true; });
    } else {
      statusEl.textContent = 'Guess the mystery huruf of the day — the clues will guide you!';
    }
  }

  function finish(won) {
    state.done = true;
    state.won = won;
    if (won) {
      state.streak = (state.streak || 0) + 1;
      state.best = Math.max(state.best || 0, state.streak);
      state.lastWinDate = today;
    } else {
      state.streak = 0;
    }
    save(state);
    updateChips();
    setStatus();
    var tries = guesses.length;
    var stars = won ? (tries <= 2 ? 3 : tries <= 4 ? 2 : 1) : 0;
    setTimeout(function () {
      if (won) { K.sound.win(); K.confetti(); }
      modal.show({
        title: won ? 'Mumtaz! It was ' + ANSWER[0] + ' (' + ANSWER[1] + ')' : 'It was ' + ANSWER[0] + ' (' + ANSWER[1] + ')',
        text: won
          ? 'Solved in ' + tries + (tries === 1 ? ' try' : ' tries') + ' · streak ' + state.streak + ' day' + (state.streak === 1 ? '' : 's') + ' · best ' + state.best
          : 'Come back tomorrow for a new mystery huruf — your streak will restart!',
        stars: stars,
        againLabel: 'See my board',
        onAgain: null
      });
    }, 500);
  }

  function guess(idx, key) {
    if (state.done || guesses.indexOf(idx) !== -1) return;
    guesses.push(idx);
    state.guesses = guesses;
    save(state);
    key.disabled = true;
    renderRow(idx, true);
    updateChips();
    if (idx === answerIdx) {
      key.classList.add('is-hit');
      K.sound.ding();
      K.vibrate(20);
      finish(true);
    } else if (guesses.length >= MAX_GUESSES) {
      K.sound.buzz();
      finish(false);
    } else {
      K.sound.tap();
      setStatus();
    }
  }

  /* --- boot: restore today's board --- */
  buildKeyboard();
  guesses.forEach(function (i) { renderRow(i, false); });
  updateChips();
  setStatus();
  setInterval(setStatus, 30000);
})();
